import Grid from "@mui/material/Grid/Grid";
import {
    CustomLabelLargeServiceDetailsBold,
    CustomLabelMediumRegular, CustomLabelMediumRegularDetailsInto,
    CustomLabelMediumSmallBold,
    // CustomLabelRegularMedium,
    // CustomLabelSmallBold, 
    CustomLabelSmallMediumRegular,
    //  CustomLabelXSmallRegular
} from "../common/CustomLabel";
import WorkCard from "../card-work";
// import Paper from "@mui/material/Paper/Paper";
import Box from "@mui/material/Box/Box";
// import PROJECT1 from "../../assets/images/project_1.png";
import React, {useState} from "react";
import {AnimatePresence, motion} from "framer-motion";
// import PROJECT_DETAILS from "../../assets/images/project-details.png";


const WorkDetails = ({title, description, work, type,onClick}) => {
    const [isHovered, setIsHovered] = useState(false);



    const onClickItem=(e)=>{

        if(onClick) onClick(e);

    }

    return (

        <>
            {
                type===1 &&
                <Grid container sx={{marginTop: {xs: "40px", md: "70x"},cursor:"pointer"}} onClick={onClickItem} item xs={12}>
                    <Grid item container>
                        <CustomLabelMediumSmallBold
                            color={"#5E17EB"}
                            text={title}/>
                    </Grid>
                    <Grid container sx={{marginTop: "10px"}}>
                        <CustomLabelMediumRegular
                            color={"#333333"}
                            normal={true}
                            lineHeight={1.2}
                            text={description}
                        />
                    </Grid>


                    <Grid item xs={12} container justifyContent={"space-between"} sx={{marginTop: "20px"}}>

                        {
                            work.map((w) =>
                                <Grid item xs={12} md={5.9} lg={5.9} xl={3.8}>
                                    <WorkCard {...w}/>
                                </Grid>
                            )
                        }


                    </Grid>
                </Grid>
            }
            {

                type===2 &&
                <Grid container sx={{marginTop: {xs: "40px", md: "70x"}}} item xs={12}>


                    <Grid item xs={12} container justifyContent={"space-between"} sx={{marginTop: "20px"}}>

                        {
                            work.map((w) =>
                                <Grid item xs={12} md={5.9}>
                                    <WorkCard {...w}/>
                                </Grid>
                            )
                        }


                    </Grid>
                </Grid>

            }

            {
                type===3 &&
                <Box
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                    className={"hover-shadow"}

                >

                    {
                        isHovered && <Box sx={{height:"100%",borderRadius: "16px",width:"100%",position:"absolute",top:0,background:"black",opacity:0.2}}/>
                    }
                    <Box component={"img"} src={work.img} alt={work.title}
                         sx={{
                             width: "100%", borderRadius: "16px",
                             minHeight: {xs: "280px", sm: "400px", md: "282px", lg: "400px"},
                             maxHeight: {xs: "280px", sm: "400px", md: "282px", lg: "400px"},
                         }}


                    ></Box>
                    <Grid item container sx={{position: "absolute", top: 0, height: "100%"}}
                          alignItems={"flex-end"}
                          justifyContent={"center"}>
                        <Grid item xs={11} container justifyContent={"center"}
                              sx={{marginBottom: "20px"}}>
                            <Grid container direction={"column"}>
                                <Grid item>
                                    <CustomLabelMediumSmallBold text={work.title}
                                                                color={"#FFFFFF"}/>
                                </Grid>
                                <Grid item>

                                    <AnimatePresence>
                                        {isHovered && (
                                            <motion.div
                                                initial={{opacity: 0, y: 10}}
                                                animate={{opacity: 1, y: 0}}
                                                exit={{opacity: 0, y: 10}}
                                                transition={{duration: 0.3}}
                                                style={{}}
                                            >
                                                <CustomLabelSmallMediumRegular normal={true}
                                                                          text={work.description}
                                                                          color={"#FFFFFF"}/>
                                            </motion.div>
                                        )}
                                    </AnimatePresence>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            }


            {
                type===4 &&
                <>

                    <Grid item sx={{width: "100%"}}>
                        <Box component={"img"} src={work.img} alt={work.title} sx={{width: "100%", minHeight: "480px",maxHeight:"120vh"}}/>
                    </Grid>


                    <Grid container alignItems={"flex-end"}
                          sx={{height: "100%", position: "absolute", bottom: {xs: "5px", sm: "10x", lg: "40px"}}}
                          justifyContent={"center"}>
                        <Grid item xs={11} sm={10} md={9} container alignItems={"center"} direction={"column"}>

                            <Grid item container
                                  justifyContent={"center"}>
                                <CustomLabelLargeServiceDetailsBold textAlign={"center"} color={"#FFFFFF"}
                                                                    text={work.title}/>
                            </Grid>
                            <Grid item container
                                  sx={{marginTop: "5px"}}
                                  justifyContent={"center"}>
                                <CustomLabelMediumRegularDetailsInto
                                    text={work.description}
                                    color={"#FFFFFF"}
                                    normal={true}
                                    style={{textAlign: "center", lineHeight: 1.2}}
                                />
                            </Grid>
                            <Grid item container justifyContent={"center"}
                                  sx={{
                                      padding: {xs: "0px 10px 10px 10px", md: "0px 16px 16px 16px"},
                                      gap: "10px",
                                      marginTop: "20px"
                                  }}>

                                {
                                    work.tags.map((t) =>
                                        <Grid item sx={{
                                            background: "white",
                                            padding: {xs: "10px", sm: "10px 20px", md: "15px 20px"},
                                            borderRadius: 16,
                                            marginTop: {xs: "10px", md: "16px"}
                                        }}>
                                            <CustomLabelSmallMediumRegular text={t}/>
                                        </Grid>
                                    )
                                }

                            </Grid>
                        </Grid>
                    </Grid>
                </>
            }



            {
                type===5 &&
                <>

                    <Grid item sx={{width: "100%", position: "relative"}}>
                        <Box component={"img"} src={work.img} alt={work.title} sx={{
                            width: "100%", 
                            minHeight: {xs: "320px", sm: "400px", md: "480px"},
                            maxHeight: "100vh",
                            objectFit: "cover"
                        }}/>
                        <Box sx={{
                            position: "absolute",
                            bottom: 0,
                            left: 0,
                            right: 0,
                            height: {xs: "45%", md: "50%"},
                            background: "linear-gradient(to top, rgba(0,0,0,0.8), rgba(0,0,0,0))"
                        }}/>
                    </Grid>

                    <Grid container alignItems={"flex-end"}
                          sx={{height: "100%", position: "absolute", bottom: {xs: "5px", sm: "10x", lg: "50px"}}}
                          justifyContent={"center"}>
                        <Grid item xs={11} sm={10} md={9} container alignItems={"center"} direction={"column"}>

                            <Grid item container
                                  justifyContent={"center"}>
                                <CustomLabelMediumRegularDetailsInto
                                    text={work.date}
                                    color={"#FFFFFF"}
                                    normal={true}
                                    style={{textAlign: "center", lineHeight: 1.2}}
                                />
                            </Grid>

                            <Grid item container
                                  sx={{marginTop: "20px"}}
                                  justifyContent={"center"}>
                                <CustomLabelLargeServiceDetailsBold component={"h1"} textAlign={"center"} color={"#FFFFFF"}
                                                                    text={work.title}/>
                            </Grid>

                        </Grid>
                    </Grid>
                </>
            }

        </>
    )


}

export default WorkDetails;
